(function() {
  "use strict";

  function initCustomSelects() {
    const nativeSelects = document.querySelectorAll(
      '[data-custom-select="true"] select, ' +
      'select[data-custom-select="true"], ' +
      '#nutrition-facts--select'
    );

    nativeSelects.forEach(createCustomSelect);

    if (!document._rockaCustomSelectOutsideClick) {
      document._rockaCustomSelectOutsideClick = true;
      document.addEventListener('click', function(e) {
        const cs = document.querySelectorAll('.CustomSelect');
        cs.forEach(select => {
          if (!select.contains(e.target)) select.classList.remove('is-open');
        });
      });
    }

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('customSelect:initialized', { bubbles: true }));
    }, 1000);
  }

  function createCustomSelect(nativeSelect) {
    if (nativeSelect.closest('.CustomSelect')) return;

    const parentContainer = nativeSelect.closest('.ProductForm__Select') ||
      nativeSelect.closest('.flavor-selector') ||
      nativeSelect.closest('.select-wrapper');
    if (!parentContainer) return;
    if (parentContainer.querySelector('.CustomSelect')) return;

    const customSelect = document.createElement('div');
    customSelect.className = 'CustomSelect';

    if (nativeSelect.id === 'nutrition-facts--select') {
      customSelect.classList.add('CustomSelect--plain');
      parentContainer.classList.add('has-custom-select');
    }

    const trigger = document.createElement('div');
    trigger.className = 'CustomSelect__Trigger';

    const current = document.createElement('span');
    current.className = 'CustomSelect__Current';

    const selectedOption = nativeSelect.options[nativeSelect.selectedIndex];

    const optionCount = Array.from(nativeSelect.options).filter(opt => {
      const t = (opt.textContent || '').trim();
      return t !== '' && !opt.disabled && !/ausverkauft/i.test(t);
    }).length;

    const isSingle = nativeSelect.dataset.single === '1' || optionCount === 1 || nativeSelect.options.length === 1;

    if (selectedOption) {
      const { flavorText } = parseOptionText(selectedOption.textContent);
      current.textContent = flavorText;
      current.setAttribute('data-flavor', flavorText);
      applyFlavorColors(current, selectedOption, flavorText);
      if (optionCount > 0) current.setAttribute('data-count', optionCount === 1 ? '1 Sorte' : optionCount + ' Sorten');
    } else {
      current.textContent = 'Select an option';
    }

    let existingArrow = parentContainer.querySelector('.CustomSelect__Arrow');
    let arrow = existingArrow || document.createElement('span');
    if (!existingArrow) arrow.className = 'CustomSelect__Arrow';

    const dropdown = document.createElement('div');
    dropdown.className = 'CustomSelect__Dropdown';

    const optionsList = document.createElement('ul');
    optionsList.className = 'CustomSelect__Options';

    Array.from(nativeSelect.options).forEach((option, index) => {
      if ((option.textContent || '').trim() === '') return;

      const { flavorText, sizeText } = parseOptionText(option.textContent);

      const optionElement = document.createElement('li');
      optionElement.className = 'CustomSelect__Option';
      optionElement.textContent = flavorText;
      optionElement.dataset.value = option.value;

      if (sizeText) optionElement.dataset.size = sizeText;

      if (option.dataset) {
        Object.keys(option.dataset).forEach(key => {
          optionElement.dataset[key] = option.dataset[key];
        });
      }

      applyFlavorColors(optionElement, option, flavorText);

      if (index === nativeSelect.selectedIndex) optionElement.classList.add('is-selected');

      if (option.disabled || option.textContent.toLowerCase().includes('ausverkauft')) {
        optionElement.classList.add('is-disabled');
        optionElement.dataset.size = 'Ausverkauft';
      }

      optionElement.addEventListener('click', function() {
        nativeSelect.selectedIndex = index;

        const { flavorText } = parseOptionText(option.textContent);

        current.textContent = flavorText;
        current.setAttribute('data-flavor', flavorText);

        applyFlavorColors(current, option, flavorText);

        if (optionCount > 0) current.setAttribute('data-count', optionCount === 1 ? '1 Sorte' : optionCount + ' Sorten');

        const allOptions = optionsList.querySelectorAll('.CustomSelect__Option');
        allOptions.forEach(opt => opt.classList.remove('is-selected'));

        this.classList.add('is-selected');
        customSelect.classList.remove('is-open');

        nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });

      optionsList.appendChild(optionElement);
    });

    dropdown.appendChild(optionsList);
    trigger.appendChild(current);

    if (!isSingle) {
      if (existingArrow) {
        parentContainer.removeChild(existingArrow);
        trigger.appendChild(existingArrow);
      } else {
        trigger.appendChild(arrow);
      }
    } else {
      if (existingArrow && existingArrow.parentNode) existingArrow.parentNode.removeChild(existingArrow);
      arrow = null;
      customSelect.classList.add('is-single');
    }

    customSelect.appendChild(trigger);
    customSelect.appendChild(dropdown);

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();

      if (isSingle) return;

      document.querySelectorAll(
        '.template-product #bogos-volume-discount-view .bogos-vl-select-variant-dropdown.opened, ' +
        '.template-product .Product__Info .bogos-volume-discount-view .bogos-vl-select-variant-dropdown.opened'
      ).forEach(closeBogosVariantDropdown);

      const allCustomSelects = document.querySelectorAll('.CustomSelect');
      allCustomSelects.forEach(select => {
        if (select !== customSelect) select.classList.remove('is-open');
      });

      customSelect.classList.toggle('is-open');
    });

    parentContainer.insertBefore(customSelect, nativeSelect);
    customSelect.appendChild(nativeSelect);

    nativeSelect.addEventListener('change', function() {
      const selectedIndex = this.selectedIndex;
      const selectedOption = this.options[selectedIndex];

      if (selectedOption) {
        const { flavorText } = parseOptionText(selectedOption.textContent);

        current.textContent = flavorText;
        current.setAttribute('data-flavor', flavorText);

        applyFlavorColors(current, selectedOption, flavorText);

        if (optionCount > 0) current.setAttribute('data-count', optionCount === 1 ? '1 Sorte' : optionCount + ' Sorten');
      } else {
        current.textContent = '';
        current.removeAttribute('data-flavor');
        current.removeAttribute('data-count');
        current.removeAttribute('data-color-secondary');
      }

      const allOptions = optionsList.querySelectorAll('.CustomSelect__Option');
      allOptions.forEach((opt, i) => {
        opt.classList.toggle('is-selected', i === selectedIndex);
      });
    });

    return customSelect;
  }

  function parseOptionText(text) {
    if (!text) return { flavorText: '', sizeText: '' };

    const isSoldOut = text.toLowerCase().includes('ausverkauft');

    if (isSoldOut) {
      text = text.replace(/\bausverkauft\b/i, '').trim();
    }

    let sizeText = '';

    text = text.replace(/\s*(?:-|\/)\s*(\d+\s*g(?:\s*\/\s*\d+\s*g)*)(.*)$/i, (_, sizes) => {
      sizeText = sizes;
      return '';
    });

    const flavorText = text.replace(/\s+/g, ' ').trim();

    return {
      flavorText,
      sizeText: isSoldOut ? 'Ausverkauft' : sizeText
    };
  }

  function normalizeName(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  let __variantColorsExactMap = null;

  function getFlavorColors(flavorText) {
    if (!window.variantColors || !Array.isArray(window.variantColors) || !flavorText) return null;

    const normFlavor = normalizeName(flavorText);

    if (!__variantColorsExactMap) {
      __variantColorsExactMap = new Map();

      for (const c of window.variantColors) {
        __variantColorsExactMap.set(normalizeName(c.name), {
          primary: c.primary,
          secondary: c.secondary
        });
      }
    }

    const exact = __variantColorsExactMap.get(normFlavor);
    if (exact) return exact;

    let best = null;
    let bestLen = 0;

    for (const c of window.variantColors) {
      const n = normalizeName(c.name);

      if (!n) continue;

      if (normFlavor.includes(n) || n.includes(normFlavor)) {
        if (n.length > bestLen) {
          best = {
            primary: c.primary,
            secondary: c.secondary
          };
          bestLen = n.length;
        }
      }
    }

    return best;
  }

  function setColorsToElement(element, primary, secondary) {
    if (!element || !primary) return;

    element.style.setProperty('--color-primary', primary);

    if (secondary) {
      element.style.setProperty('--color-secondary', secondary);
      element.setAttribute('data-color-secondary', 'true');
    } else {
      element.style.removeProperty('--color-secondary');
      element.removeAttribute('data-color-secondary');
    }

    const customSelect = element.closest('.CustomSelect');

    if (customSelect && customSelect !== element) {
      customSelect.style.setProperty('--color-primary', primary);

      if (secondary) {
        customSelect.style.setProperty('--color-secondary', secondary);
      } else {
        customSelect.style.removeProperty('--color-secondary');
      }
    }
  }

  function applyFlavorColors(element, option, flavorText) {
    // Priority 1: colors from metaobject reference
    if (option && option.dataset && option.dataset.metaColorPrimary) {
      const primary = option.dataset.metaColorPrimary;
      const secondary = option.dataset.metaColorSecondary || '';

      setColorsToElement(element, primary, secondary);
      return;
    }

    // Priority 2: colors from variant metafields rendered into option data-attributes
    if (option && option.dataset && option.dataset.flavorColorPrimary) {
      const primary = option.dataset.flavorColorPrimary;
      const secondary = option.dataset.flavorColorSecondary || '';

      setColorsToElement(element, primary, secondary);
      return;
    }

    // Priority 3: JSON fallback from window.variantColors
    const variantColors = getFlavorColors(flavorText);

    if (variantColors && variantColors.primary) {
      setColorsToElement(element, variantColors.primary, variantColors.secondary || '');

      if (option && option.dataset) {
        option.dataset.flavorColorPrimary = variantColors.primary;
        option.dataset.flavorColorSecondary = variantColors.secondary || '';
      }
    } else if (option && option.dataset) {
      element.style.removeProperty('--color-primary');
      element.style.removeProperty('--color-secondary');
      element.removeAttribute('data-color-secondary');

      const customSelect = element.closest('.CustomSelect');

      if (customSelect && customSelect !== element) {
        customSelect.style.removeProperty('--color-primary');
        customSelect.style.removeProperty('--color-secondary');
      }
    }
  }

  function getVariantColorById(variantId) {
    if (!variantId) return null;

    const directMap = window.rockaVariantColorById;

    if (directMap && directMap[variantId]) {
      return directMap[variantId];
    }

    const script = document.querySelector('script[data-rocka-variant-colors], script[id^="mcp-vc-"]');

    if (!script) return null;

    try {
      const parsed = JSON.parse(script.textContent || '{}');

      window.rockaVariantColorById = Object.assign({}, window.rockaVariantColorById || {}, parsed);
      return window.rockaVariantColorById[variantId] || null;
    } catch (error) {
      return null;
    }
  }

  function applyBogosFlavorColors(element, text, variantId) {
    if (!element) return;

    const colorsById = getVariantColorById(variantId);
    const colorsByName = colorsById && colorsById.cp
      ? { primary: colorsById.cp, secondary: colorsById.cs || '' }
      : getFlavorColors(parseOptionText(text).flavorText);
    const primary = colorsByName && (colorsByName.primary || colorsByName.cp);
    const secondary = colorsByName && (colorsByName.secondary || colorsByName.cs || '');

    if (!primary) return;

    element.style.setProperty('--color-primary', primary);
    element.style.setProperty('--cp', primary);

    if (secondary) {
      element.style.setProperty('--color-secondary', secondary);
      element.style.setProperty('--cs', secondary);
      element.setAttribute('data-color-secondary', 'true');
    } else {
      element.style.removeProperty('--color-secondary');
      element.style.removeProperty('--cs');
      element.removeAttribute('data-color-secondary');
    }

    element.setAttribute('data-has-swatch', 'true');
  }

function initBogosVariantSwatches() {
  const roots = document.querySelectorAll(
    '.template-product #bogos-volume-discount-view, ' +
    '.template-product .Product__Info .bogos-volume-discount-view'
  );

  roots.forEach(root => {
    const tierInputs = root.querySelectorAll(
      '.bogos-volume-discount-tier-input'
    );

    if (
      tierInputs.length &&
      !root.querySelector('.bogos-volume-discount-tier-input:checked')
    ) {
      tierInputs[0].checked = true;
      tierInputs[0].setAttribute('checked', 'checked');
    }

    root
      .querySelectorAll('.bogos-vl-select-variant-dropdown')
      .forEach(dropdown => {
        const input = dropdown.querySelector(
          '.bogos-vl-select-variant-title-input'
        );

        const text = input
          ? input.value || input.getAttribute('value') || ''
          : '';

        const variantId = input
          ? input.getAttribute('data-variant-id')
          : '';

        /*
         * Initialize the flavor preview first.
         * This must run even if the count cannot be calculated.
         */
        applyBogosFlavorColors(dropdown, text, variantId);

        if (input) {
          input.setAttribute('data-has-swatch', 'true');
        }

        // Calculate the real flavor count without external helpers.
        const optionCount = dropdown.querySelectorAll(
          '.bogos-vl-select-variant-option'
        ).length;

        if (optionCount > 0) {
          const isGerman = document.documentElement.lang
            .toLowerCase()
            .startsWith('de');

          const label = isGerman
            ? (optionCount === 1 ? 'Sorte' : 'Sorten')
            : (optionCount === 1 ? 'flavor' : 'flavors');

          dropdown.setAttribute(
            'data-flavor-count',
            `${optionCount} ${label}`
          );
        } else {
          dropdown.removeAttribute('data-flavor-count');
        }
      });

    root
      .querySelectorAll('.bogos-vl-select-variant-option')
      .forEach(option => {
        applyBogosFlavorColors(
          option,
          option.textContent || '',
          option.getAttribute('data-variant-id')
        );
      });
  });
}

  function closeBogosVariantDropdown(dropdown) {
    dropdown.classList.remove('opened');
    const input = dropdown.querySelector('.bogos-vl-select-variant-title-input');
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function watchBogosVariantSwatches() {
    if (document._rockaBogosVariantSwatches) return;

    document._rockaBogosVariantSwatches = true;
    initBogosVariantSwatches();

    document.addEventListener('click', function(event) {
      if (event.target.closest('#bogos-volume-discount-view, .Product__Info .bogos-volume-discount-view')) {
        const option = event.target.closest('.bogos-vl-select-variant-option');
        const dropdown = option && option.closest('.bogos-vl-select-variant-dropdown');
        setTimeout(function() {
          if (dropdown) closeBogosVariantDropdown(dropdown);
          initBogosVariantSwatches();
        }, 0);
      }
    }, true);

    document.addEventListener('change', initBogosVariantSwatches);

    const observer = new MutationObserver(function() {
      initBogosVariantSwatches();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'data-variant-id']
    });
  }

  function getSvgArrow() {
    return '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L5 4.5L9 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCustomSelects();
      watchBogosVariantSwatches();
    });
  } else {
    initCustomSelects();
    watchBogosVariantSwatches();
  }

  document.addEventListener('shopify:section:load', initCustomSelects);
  document.addEventListener('shopify:block:select', initCustomSelects);
  document.addEventListener('variant:changed', function() {
    setTimeout(initCustomSelects, 0);
  });

  window.initCustomSelects = initCustomSelects;
  window.initBogosVariantSwatches = initBogosVariantSwatches;
})();
